import React from 'react';
import Certifications from '../components/UI/Certifications';

const CertificationsPage = () => {
  return (
    <div className="certifications-page">
      <Certifications />
    </div>
  );
};

export default CertificationsPage; 